import { Injectable, signal } from '@angular/core';
import { first } from 'rxjs/operators';
import { SearchMode } from '../../components/search/search-mode';
import { SearchService } from './search.service';
import { TerritoryTreeService } from './territory-tree.service';
import { TerritoryCountersService } from './territory-counters.service';
import { firstValueFrom } from 'rxjs';
import { ArticleImSearchService } from './article-im-search.service';

export enum SmartSearchSource {
  PRESS = 'press',
  ADMIN_DOC = 'adminDoc',
  WEB = 'web',
}

export const SMART_SEARCH_SESSIONS_KEY = 'smart-search-sessions';
export const TAB_ID_KEY = 'smart-search-tab-id';

@Injectable({
  providedIn: 'root',
})
export class SmartSearchService {
  modalOpen = signal(false);
  context =  signal<object>({});

  constructor(
    private searchService: SearchService,
    private articleImSearchService: ArticleImSearchService,
    private territoryTreeService: TerritoryTreeService,
    private territoryCountersService: TerritoryCountersService,
  ) {}

  async openSmartSearchModal(data?: any) {
    const impacterId = data?.['impacterId'];

    await firstValueFrom(this.searchService.getSearch().pipe(first())).then(async (search: any) => {
      const checkedTerritories = search.filters?.territories || [];
      const perimeter = search.perimeter;
      const adminDocSources = search.filters?.source;

      const territoryTree = this.territoryTreeService.getTerritoryTree();

      let topic: {id: number, name: string} | undefined, keywords: string | undefined;
      const service = impacterId ? this.articleImSearchService : this.searchService;
      if (service.searchValue) {
        if (typeof service.searchValue === 'string') {
          keywords = service.searchValue;
        } else {
          topic = service.searchValue;
        }
      }
      let pressSources: string[] = [];
      await firstValueFrom(this.territoryCountersService.getTerritoryCounters())
        .then((territoryCounters) => {
          pressSources = territoryCounters.sourcesTerritories.map(
            (source) => source.name
          );
        });

      this.context.set({
        territories: checkedTerritories,
        perimeter: perimeter,
        territoryTree: territoryTree,
        adminDocSources: adminDocSources,
        pressSources: pressSources,
        topic: topic?.name,
        topicId: topic?.id,
        keywords: keywords,
        impacterId: impacterId,
      });
    });
    this.modalOpen.set(true);
  }
}
